import(/* webpackMode: "eager" */ "/vercel/path0/app/formations/page.tsx")